// bottomSheetSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BottomSheetState {
  isOpen: boolean;
  component: React.ComponentType<any> | null;
  props?: Record<string, any>;
  height?: number;
}

const initialState: BottomSheetState = {
  isOpen: false,
  component: null,
  props: {},
  height: 300,
};

const bottomSheetSlice = createSlice({
  name: "bottomSheet",
  initialState,
  reducers: {
    openSheet: (
      state,
      action: PayloadAction<Omit<BottomSheetState, "isOpen">>
    ) => {
      state.isOpen = true;
      state.component = action.payload.component;
      state.props = action.payload.props || {};
      state.height = action.payload.height || 300;
    },
    closeSheet: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openSheet, closeSheet } = bottomSheetSlice.actions;
export default bottomSheetSlice.reducer;

// Selector
export const selectBottomSheet = (state: { bottomSheet: BottomSheetState }) =>
  state.bottomSheet;
